import { actionTypes } from '../actions/actionTypes'

const initialState = {
  user: null,
  created: null,
  loading: null,
  error: null
}

export default (state = initialState, action) => {
  switch(action.type){
  case actionTypes.USER.SET_USER:
    return { ...state, user: action.value }
  case actionTypes.USER.SET_CREATED:
    return { ...state, created: action.value }
  case actionTypes.USER.SET_LOADING:
    return { ...state, loading: action.value }
  case actionTypes.USER.SET_ERROR:
    return { ...state, error: action.value }
  default:
    return state
  }
}